import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { saveToIndexedDB, syncDataToServer } from "../../utils/storage";

export interface WishlistItem {
  id: string | number;
  name: string;
  category: string;
  price: number;
  emoji?: string;
  image?: string;
}

interface WishlistState {
  items: WishlistItem[];
}

const initialState: WishlistState = {
  items: [],
};

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    syncWishlist: (state, action: PayloadAction<WishlistItem[]>) => {
      state.items = action.payload;
    },
    toggleWishlist: (
      state,
      action: PayloadAction<{ item: WishlistItem; email: string }>,
    ) => {
      const { item, email } = action.payload;
      const index = state.items.findIndex((i) => i.id === item.id);
      if (index >= 0) {
        state.items.splice(index, 1);
      } else {
        state.items.push(item);
      }
      if (typeof window !== "undefined") {
        saveToIndexedDB(`nakman_wishlist_${email}`, state.items);
        syncDataToServer(email, { wishlist: state.items });
      }
    },
    resetWishlist: (state) => {
      state.items = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase("auth/logoutAll", (state) => {
      state.items = [];
    });
  },
});

export const { syncWishlist, toggleWishlist, resetWishlist } =
  wishlistSlice.actions;
export default wishlistSlice.reducer;
